// Create-action stage gates — the SINGLE source of truth for which project
// stages offer "New presentation" / "New estimate".
//
// Before 2026-07-27 these lived twice: the server rule engine
// (services/projects.ts getAvailableActions) had inline stage conditions, and
// the frontend (lib/projectStage.ts) hand-duplicated the same literals to gate
// the in-context create affordances that replaced the removed Actions ▾
// dropdown. A backend matrix change would silently drift the frontend gate
// (proven in review). Extracting the sets here — same treatment as
// reopen-stage.ts — makes both consume one definition, and lets the offline gate
// EXECUTE an equivalence check (getAvailableActions vs these predicates) across
// every stage. DB-free.
//
// Forward-only (operator 2026-06-11): once a project reaches Estimate you can't
// add a presentation; once it commits a Quote you can't add an estimate.

/** Stages where create_presentation is offered. */
export const CREATE_PRESENTATION_STAGES = [
  "opportunity",
  "presentation",
] as const;

/** Stages where create_estimate is offered (multiple estimates per project are
 *  legal, so it stays available AT the estimate stage too). */
// CEO 2026-10-15 ("Opportunity → Quote"): an opportunity can hold several
// quotes and more than one buying decision, so a new quote can start at any
// live stage — only a closed or lost opportunity stops it.
export const CREATE_ESTIMATE_STAGES = [
  "opportunity",
  "presentation",
  "estimate",
  "sales_order",
  "in_production",
  "shipped",
  "invoiced",
] as const;

export function canCreatePresentationAtStage(stage: string): boolean {
  return (CREATE_PRESENTATION_STAGES as readonly string[]).includes(stage);
}

export function canCreateEstimateAtStage(stage: string): boolean {
  return (CREATE_ESTIMATE_STAGES as readonly string[]).includes(stage);
}
